"use client"
import type { FragmentOf } from "@opensea/graphql"
import { graphql, readFragment } from "@opensea/graphql"
import { SpaceBetween, TextBody, TextOverflowTooltip } from "@opensea/ui-kit"
import { FilterPanel } from "./FilterPanel"
import {
  TraitFiltersNumericTraitInput,
  TraitFiltersNumericTraitInputFragment,
} from "./TraitFiltersNumericTraitInput"
import {
  TraitFiltersStringTraitInput,
  TraitFiltersStringTraitInputFragment,
} from "./TraitFiltersStringTraitInput"

export const TraitFilterPanelFragment = graphql(
  `
    fragment TraitFilterPanelFragment on CollectionAttribute {
      traitType
      range {
        __typename
      }
      values {
        __typename
      }
      ...TraitFiltersStringTraitInputFragment
      ...TraitFiltersNumericTraitInputFragment
    }
  `,
  [TraitFiltersStringTraitInputFragment, TraitFiltersNumericTraitInputFragment],
)

type Props = {
  attribute: FragmentOf<typeof TraitFilterPanelFragment>
  disableHighItemCounts?: boolean
  defaultOpen?: boolean
}

export function TraitFilterPanel({
  attribute: attributeKey,
  disableHighItemCounts,
  defaultOpen,
}: Props) {
  const attribute = readFragment(TraitFilterPanelFragment, attributeKey)

  return (
    <FilterPanel
      content={
        attribute.range ? (
          <TraitFiltersNumericTraitInput attribute={attribute} />
        ) : (
          <TraitFiltersStringTraitInput
            attribute={attribute}
            disableHighItemCounts={disableHighItemCounts}
          />
        )
      }
      defaultOpen={defaultOpen}
    >
      <SpaceBetween className="w-full max-w-[calc(100%-24px)] grow gap-2">
        <TextOverflowTooltip>{attribute.traitType}</TextOverflowTooltip>
        <TextBody>{attribute.values.length}</TextBody>
      </SpaceBetween>
    </FilterPanel>
  )
}
